import { ArrowOutward } from '@mui/icons-material';
import { type RpmPicks } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import clsx from 'clsx';
import { ConfidenceBar } from 'components/Db/Profile/Rpm/ConfidenceBar';

import styles from './RpmConfidenceChange.module.scss';

export const RpmConfidenceChange = ({ pick }: { pick: RpmPicks }) => {
  const { organization, confidence, previousConfidence } = pick;

  const teamName = organization?.name || organization?.fullName || 'Team';
  const changeDirection =
    (confidence ?? 100) > (previousConfidence ?? 0) ? 1 : -1;

  return (
    <div className={styles.block}>
      <dl className={styles.team}>
        <dt>{teamName}</dt>
        <dd className={styles.changeContainer}>
          <div className={styles.change}>
            <figure>
              <Avatar
                altText={`${organization?.name} avatar`}
                className={styles.avatar}
                domain={organization?.asset?.domain}
                height={20}
                source={organization?.asset?.source}
                teamAvatar
                title={teamName}
                type={organization?.asset?.type}
                width={20}
              />
            </figure>
            <div className={styles.rankContainer}>
              <ConfidenceBar
                className={styles.confidenceBar}
                confidence={previousConfidence}
                fade
              />
            </div>
          </div>

          <ArrowOutward
            className={clsx(styles.arrow, {
              [styles.up]: changeDirection === 1,
              [styles.down]: changeDirection === -1,
            })}
          />

          <div className={styles.change}>
            <div className={styles.rankContainer}>
              <ConfidenceBar
                className={styles.confidenceBar}
                confidence={confidence}
              />
            </div>
          </div>
        </dd>
      </dl>
    </div>
  );
};
